import { useEffect, useState } from 'react'
import { collection, onSnapshot, query, where, limit } from 'firebase/firestore'
import { db } from '../../../firebase'
import { useNavigate } from 'react-router-dom'

import './main.css'

function FreeCoursesOnMain() {
  const [courses, setCourses] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    const q = query(collection(db, 'courses'), where('type', '==', 'free'), limit(8))

    const unsub = onSnapshot(q, (snapshot) => {
      setCourses(
        snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
      )
    })

    return () => unsub()
  }, [])

  return (
    <div className="container-courses">
      <div className="courses-control">
        {courses.map((course) => (
          <button
            className="courses"
            key={course.id}
            onClick={() => navigate(`/courses/free/${course.id}`)}
          >
            <h3>{course.title}</h3>
            <p>{course.description}</p>
          </button>
        ))}
      </div>

      <div className="see-more-control">
        <button className="see-more" onClick={() => navigate('/courses/free')}>
          Все курсы
        </button>
      </div>
    </div>
  )
}

export default FreeCoursesOnMain
